export function isAuthenticationError(error: unknown): error is { status: number } {
  return error !== null && typeof error === 'object' && 'status' in error && error.status === 401;
}
